import { ISelect } from "@interfaces/Shared/select";

interface IUseStates {
  GetState: (state: boolean) => ISelect;
  GetStates: () => ISelect[];
}

const useStates = (): IUseStates => {
  const GetState = (state: boolean) => {
    if (state) {
      return { label: "Enabled", value: "1" };
    }

    return { label: "Disabled", value: "0" };
  };

  const GetStates = () => {
    return [
      { label: "Enabled", value: "1" },
      { label: "Disabled", value: "0" },
    ];
  };

  return { GetState, GetStates };
};

export default useStates;
